<template>
  <div class="nav">
    <div :class="{ gray: unfold || gray }" class="top clear">
      <div class="logo" v-bind:class="'logo-' + tenant" @click="toMain"></div>
      <div v-if="unfold" class="close icon" @click="spread"></div>
      <div v-if="!unfold" class="unfold icon" @click="spread"></div>
    </div>
    <transition name="fade">
      <div v-if="unfold" class="slide">
        <div class="inn">
          <!-- 开关 -->
          <div class="clear">
            <div
              class="on-off"
              v-bind:class="{ on: mode == 'on' }"
              @click="turn"
            >
              <div class="circle">
                <span v-if="mode == 'off'">OFF</span
                ><span v-if="mode == 'on'">ON</span>
              </div>
              <div class="text">Mode</div>
            </div>
          </div>
          <!-- 二级 -->
          <ul class="lst">
            <router-link
              tag="li"
              to="/"
              v-bind:class="[
                tenantTranClass(d),
                tenantCurClass('/'),
                tenantClass('/')
              ]"
            >
              <span>Home</span></router-link
            >
            <li :class="{ tran: b }">
              <a :href="evtutl" target="_blank">Events</a>
            </li>
            <li :class="{ tran: c }">
              <a :href="eduurl" target="_blank">Education</a>
            </li>
            <router-link
              tag="li"
              to="/faq"
              v-bind:class="[
                tenantTranClass(d),
                tenantCurClass('/faq'),
                tenantClass('/faq')
              ]"
              @click="fresh('/faq')"
              ><span>FAQ</span></router-link
            >
            <!--<router-link :class="{'tran': e,'cur': $route.path == '/account', tenantAccountClassCur(), tenantAccountClass() }" to="/account" tag="li" @click="fresh('/account')"><span><i v-if="number > 0"></i>Account</span></router-link>-->
            <router-link
              tag="li"
              to="/account"
              v-bind:class="[
                tenantTranClass(e),
                tenantCurClass('/account'),
                tenantClass('/account')
              ]"
              @click="fresh('/account')"
              ><span><i v-if="number > 0"></i>Account</span>
            </router-link>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  inject: ["reload"],
  data() {
    return {
      unfold: false, // 是否展开二级菜单
      mode: "off",
      urlLst: [],
      evtutl: "",
      eduurl: "",
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      anum: 0,
      bnum: 0,
      cnum: 0,
      dnum: 0,
      enum: 0,
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    if (localStorage.getItem("mode")) {
      that.mode = localStorage.getItem("mode");
    }
    that.change({ data: that.mode });
    that.getUrl({ callback: that.callback });
  },
  methods: {
    ...mapMutations("login", ["change", "setUrl"]),
    ...mapActions("login", ["getUrl"]),
    turn() {
      var that = this;
      if (that.mode == "off") {
        // 存本地是给其他页面用的，保持刷新页面也有效
        localStorage.setItem("mode", "on");
        // 这个是在当前页面用的
        that.mode = "on";
        // 这个是为了让其他页面联动起来
        that.change({ data: "on" });
      } else {
        localStorage.setItem("mode", "off");
        that.mode = "off";
        that.change({ data: "off" });
      }
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.forEach((v, i) => {
          if (v.type == 1) {
            that.evtutl = v.url;
          }
          if (v.type == 2) {
            that.eduurl = v.url;
          }
        });
        that.urlLst = res.data.data;
        that.setUrl({
          data: {
            evtutl: that.evtutl,
            eduurl: that.eduurl
          }
        });
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    toMain() {
      var that = this;
      if (that.$route.path !== "/") {
        that.$router.push("/");
      } else {
        that.reload();
      }
    },
    turn() {
      var that = this;
      if (that.mode === "off") {
        // 存本地是给其他页面用的，保持刷新页面也有效
        localStorage.setItem("mode", "on");
        // 这个是在当前页面用的
        that.mode = "on";
        // 这个是为了让其他页面联动起来
        that.change({ data: "on" });
      } else {
        localStorage.setItem("mode", "off");
        that.mode = "off";
        that.change({ data: "off" });
      }
    },
    // 点击展开
    spread() {
      var that = this;
      that.unfold = !that.unfold;
      clearTimeout(that.anum);
      clearTimeout(that.bnum);
      clearTimeout(that.cnum);
      clearTimeout(that.dnum);
      clearTimeout(that.enum);
      if (!that.a) {
        that.anum = setTimeout(() => {
          that.a = true;
        }, 50);
        that.bnum = setTimeout(() => {
          that.b = true;
        }, 100);
        that.cnum = setTimeout(() => {
          that.c = true;
        }, 150);
        that.dnum = setTimeout(() => {
          that.d = true;
        }, 200);
        that.enum = setTimeout(() => {
          that.e = true;
        }, 250);
      } else {
        that.a = false;
        that.b = false;
        that.c = false;
        that.d = false;
        that.e = false;
      }
    },
    fresh(path) {
      if (this.$route.path == path) {
        this.reload();
      } else {
        this.$router.push(path);
      }
      if (path == "/account") {
        // 获取消息通知
        this.getInvoiceNums({ callback: this.numCallback });
      }
    },
    ...mapActions("account", ["getInvoiceNums"]),
    ...mapMutations("login", ["setNumber"]),
    // 获取消息通知回调
    numCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.setNumber({ number: res.data.data });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    tenantCurClass(p) {
      let className = "";
      if (this.$route.path == p) {
        className = "cur";
      }
      return className;
    },
    tenantClass(p) {
      let className = "";
      if (this.$route.path == p) {
        className = "tenant-" + this.tenant;
      }
      return className;
    },
    tenantTranClass(x) {
      let className = "";
      if (x) {
        className = "tran";
      }
      return className;
    }
  },
  props: {
    gray: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      number: state => state.login.number
    })
  }
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 12;

  .top {
    width: 100%;
    height: 1.04rem;
    transition: all 0.5s;

    .logo {
      width: 1.4rem;
      height: 0.56rem;
      margin: 0.24rem 0 0.24rem 0.24rem;
      float: left;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      //background-image: url('../../assets/logo.png');
      cursor: pointer;
    }

    .icon {
      width: 1.04rem;
      height: 1.04rem;
      float: right;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 0.6rem 0.6rem;
      cursor: pointer;
    }

    .close {
      background-image: url("../../assets/clo2.png");
    }

    .unfold {
      background-image: url("../../assets/fold.png");
    }
  }

  .gray {
    background: #3f3f46;
  }

  .slide {
    background: rgba(0, 0, 0, 0.59);
    position: fixed;
    top: 1.04rem;
    width: 100%;
    bottom: 0;
    left: 0;

    .inn {
      background: #fff;
      width: 5.54rem;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;

      .on-off {
        width: 2.54rem;
        height: 0.62rem;
        border-radius: 0.36rem;
        margin-top: 0.48rem;
        float: right;
        margin-right: 0.42rem;
        position: relative;
        background: rgba(0, 0, 0, 0.2);
        margin-bottom: 0.48rem;
        cursor: pointer;

        .circle {
          width: 0.56rem;
          height: 0.56rem;
          border-radius: 50%;
          background: #fff;
          position: absolute;
          right: 0.03rem;
          top: 0.03rem;
          font-size: 0.16rem;
          color: #3f3f46;
          line-height: 0.56rem;
          text-align: center;
          transition: all 0.5s;
          font-family: ProximaNova-Semibold;
        }

        .text {
          margin-left: 0.8rem;
          line-height: 0.66rem;
          font-size: 0.24rem;
          transition: all 0.5s;
          font-family: ProximaNova-Semibold;
          color: #fff;
        }
      }

      .on {
        .circle {
          right: 1.95rem;
        }

        .text {
          margin-left: 1.1rem;
        }
      }

      .lst {
        width: 100%;
        box-sizing: border-box;
        padding-left: 0.58rem;

        li {
          font-size: 0.36rem;
          line-height: 0.22rem;
          margin-bottom: 0.8rem;
          color: rgba(63, 63, 70, 1);
          position: relative;
          left: 5rem;
          opacity: 0;
          transition: all 0.8s;
          cursor: pointer;

          a {
            display: inline-block;
            padding: 0 0.16rem;
            color: rgba(63, 63, 70, 1);
            text-decoration: none;
            margin: 0;
            padding: 0;
          }

          span {
            position: relative;

            i {
              position: absolute;
              left: 1.5rem;
              top: -0.05rem;
              display: block;
              width: 0.48rem;
              height: 0.48rem;
              background-size: 0.48rem 0.48rem;
              background-position: left center;
              background-repeat: no-repeat;
              background-image: url("../../assets/Alert.png");
            }
          }
        }

        .cur {
          font-family: ProximaNova-Semibold;

          span {
            position: relative;
          }

          span:after {
            content: "";
            display: block;
            width: 100%;
            height: 0.06rem;
            //background: #FFEF00;
            position: absolute;
            left: 0;
            top: 0.4rem;
          }
        }

        .tran {
          opacity: 1;
          left: 0;
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/nav.vue